import "./prasora-wsi.css";

import m from "mithril";
import svg from "../svg";
import modal from "../modal/modal";

export default () => {
    let ws = null;
    let wi = null;
    let initiated = false;
    let showmodal = false;
    let updating = false;


    function UpdateStatusForWSI() {
        let status = "ontime";
        if (wi.posdel <= 0) {
            if (Math.abs(wi.posdel) < 3) {
                status = "due";
            }
        } else {
            if (Math.abs(wi.posdel) < 3) {
                status = "intime";
            } else {
                status = "late";
            }
        }
        return status;
    }


    function UpdateWorkstepInstance(actionname, value) {

    }

    return {
        view: v => {
            if (!initiated) {
                ws = v.attrs.ws;
                wi = v.attrs.wi;
                wi.completed = (wi.completed == "True");
                wi.isdue = (wi.isdue == "True");
                initiated = true;
            }

            let status = UpdateStatusForWSI();

            if (updating) {
                return m("a.prasora-wsi", [m(svg, {
                    name: "loader"
                })]);
            } else {
                if (showmodal) {
                    return m(modal, [
                        m(".modal-wsi", [
                            m(".modal-wsi-header", [
                                m(".modal-wsi-title", `${ws.name}: ${wi.name}`),
                                m(".modal-cancel-button", {
                                    onclick: () => {
                                        showmodal = false;
                                    }
                                }, [m(svg, {
                                    name: "delete"
                                })])
                            ]),
                            m(".modal-wsi-body", [
                                //m(".modal-wsi-previous-activities"),
                                m(".modal-wsi-current-activity", [
                                    m(".modal-wsi-message", wi.wf ? `` : `This activity is due for ${wi.duefor}. Expected date of completion is ${wi.expectedon}. `),
                                    m(".modal-wsi-remarks"),
                                    m(".modal-wsi-history"),
                                    m(".modal-wsi-actions")
                                ]),
                                //m(".modal-wsi-next-activities")
                            ])
                        ])
                    ])
                } else return m("a.prasora-wsi", {
                    class: `wsi-${status} ${wi.completed?"wsi-completed": (wi.isdue?"wsi-isdue": "wsi-notdue")}`,
                    title: `${ws.name}: ${wi.name}${ws.posdel > 0 ? `
Delayed by ${wi.posdel} day${wi.posdel > 1? 's':''}`:""}${wi.completed?`
Completed on ${wi.completedon}`:""}
${wi.posdel}
                `,
                    onclick: () => {
                        showmodal = true;
                    }
                }, [
                    (wi.completed ? m(svg, {
                        name: "activitydone",
                    }) : (wi.isdue ? m(svg, {
                        name: "activitydue"
                    }) : m(svg, {
                        name: "activitypending"
                    })))
                ]);
            }
        }
    }
}